import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@reach/router';
import { getPage } from 'utils/pages';
import AppButton from 'components/AppButton';
import SectionHeading from 'components/SectionHeading';
import SectionSubtitle from 'components/SectionSubtitle';

const useStyles = makeStyles((theme) => {
  const s = (x) => theme.spacing(x);
  return {
    bookRepairBtn: {
      [theme.breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
    inner: {
      textAlign: 'center',
      paddingLeft: s(2),
      paddingRight: s(2),
      maxWidth: 360,
      margin: '0 auto',
    },
    headline: {
      color: '#ffffff',
      textTransform: 'uppercase',
      marginBottom: s(1.5),
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
    },
    subheadline: {
      color: '#ffffff',
      marginBottom: s(3),
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.6)',
    },
  };
});

export const BannerSliderItemMobile = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className="container" style={{ height: '100%' }}>
      <Box className={classes.inner}>
        <SectionHeading component="h2" size="medium" className={classes.headline}>{t('Still in love with your favourites?')}</SectionHeading>
        <SectionSubtitle size="large" className={classes.subheadline}>{t('Banner subheadline')}</SectionSubtitle>
        <AppButton className={classes.bookRepairBtn} color="secondary" component={Link} to={`${getPage('product')}${getPage('select')}`} variant="contained">
          {t('BookRepair')}
        </AppButton>
      </Box>
    </div>
  );
};
